const CreateCDActionTypes = {
  SET_EDITING_ID: 'SET_EDITING_ID',
  CLEAR_EDITING_ID: 'CLEAR_EDITING_ID',
  EDIT_CD_INFO: 'EDIT_CD_INFO',
  SET_SELECTED_CAMPAIGN: 'SET_SELECTED_CAMPAIGN',
  SET_MAXIMUM_DUE_DATE: 'SET_MAXIMUM_DUE_DATE',
  CLEAR_SELECTED_CAMPAIGN: 'CLEAR_SELECTED_CAMPAIGN',
  SET_CD_DEFAULT_INFO: 'SET_CD_DEFAULT_INFO',
  SET_CD_INFO: 'SET_CD_INFO',
  RESET_CD_INFO: 'RESET_CD_INFO',
  ADD_NEW_CD: 'ADD_NEW_CD',
  SET_CD_LIST: 'SET_CD_LIST',
  SET_CD_ID: 'SET_CD_ID',
  SET_REQUEST_VOUCHER: 'SET_REQUEST_VOUCHER',
  // FOR messenger order
  SET_MESSENGER_ORDER_ID: 'SET_MESSENGER_ORDER_ID'
};

export default CreateCDActionTypes;
